import React from 'react';

import {AnalyticsParameterValue} from 'insights/parameters/__generated/AnalyticsParameterValue';
import {updateConfig, updateValueJsonForConfig} from 'insights/parameters/data/ParameterListOperations';
import sortParameterConfigs from 'insights/parameters/data/sortParameterConfigs';
import {gqlGetValueJsonForConfig} from 'insights/parameters/data/ValueGetters';
import ParameterPillList from 'insights/parameters/ParameterPillList';
import {JSONValue} from 'util/Types';

import {AnalyticsParameterConfigGraphQL} from '../../../../../graphql-fragments/insights/__generated/AnalyticsParameterConfigGraphQL';
import DashboardDetailsParameterPill from './DashboardDetailsParameterPill';

export interface DashboardDetailsParameterPillProps {
  areQueriesRunning: boolean;
  onChangeParameterConfigs: (newParameterValues: Array<AnalyticsParameterConfigGraphQL>) => void;
  onChangeParameterValues: (newParameterValues: Array<AnalyticsParameterValue>) => void;
  parameterConfigs: Array<AnalyticsParameterConfigGraphQL>;
  parameterValues: Array<AnalyticsParameterValue>;
}

/**
 * Component to view and edit a list of parameters in dashboard details
 */
export default function DashboardDetailsParameterPillList(
  props: DashboardDetailsParameterPillProps
): JSX.Element {
  function handleChangeConfig(updatedConfig: AnalyticsParameterConfigGraphQL): void {
    const newConfigs = updateConfig(props.parameterConfigs, updatedConfig);
    props.onChangeParameterConfigs(newConfigs);
  }
  function handleChangeValueJson(configId: string, valueJson: JSONValue): void {
    const newValues = updateValueJsonForConfig(
      props.parameterConfigs,
      props.parameterValues,
      configId,
      valueJson
    );
    props.onChangeParameterValues(newValues);
  }

  return (
    <ParameterPillList>
      {sortParameterConfigs(props.parameterConfigs).map((config) => (
        <DashboardDetailsParameterPill
          key={config.id}
          config={config}
          valueJson={gqlGetValueJsonForConfig(props.parameterValues, config.id)}
          onChangeConfig={handleChangeConfig}
          onChangeValueJson={handleChangeValueJson}
          areQueriesRunning={props.areQueriesRunning}
        />
      ))}
    </ParameterPillList>
  );
}
